import Login from './components/Login';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';

import './assets/Login.css';

import {
  loadActiveUser,
  loadAgency
} from '../../shared/redux/entities/actions';

import {
  requestAuthTokenWithCredentials
} from '../../shared/redux/auth/actions';

import {
  getActiveUser
} from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const activeUser = getActiveUser(state);

  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend,
    pathname:props.location.pathname,
    redirectedFrom:props.location.state ? props.location.state.from : null,
    message:props.location.state ? props.location.state.message : null,
    isLoggedIn:get(state,['auth','token']) !== null,
    activeUser:activeUser,
    activeUserAgencyName:get(state,['entities','agencies',activeUser.agencyId,'name']),
    shouldAlertSalesTeamToLogin:true
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    requestAuthTokenWithCredentials,
    loadActiveUser,
    loadAgency
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/routes/Login/index.js